import {inject, Pipe, PipeTransform} from '@angular/core';
import {Observable, of} from 'rxjs';
import {Deliverable} from '../../components/dex/dex-streaming/types/deliverable';
import {TrancheId} from '../../components/dex/dex-streaming/types/tranche';
import {DexTrancheUtilityService} from '../../components/dex/dex-tranche-utility/dex-tranche-utility.service';

@Pipe({
    name: 'delBuyMinMaxQty',
    pure: true
})
export class DelBuyMinMaxQtyPipe implements PipeTransform {

    private readonly dexTrancheUtilityService = inject(DexTrancheUtilityService);

    public transform(trId: TrancheId, d: Deliverable): Observable<
        {min: number, max: number, refMin: bigint, refMax: bigint}
        | undefined
    > {
        return trId && d
            ? this.dexTrancheUtilityService.getBuyMinMaxNumStream(trId, d)
            : of(undefined);
    }

}
